import React, { Component } from 'react'
import PropTypes from 'prop-types'

class RangeForm extends Component {
  constructor(props) {
    super(props)

    this.state = {
      value: 0
    }
  }

  componentWillMount() {
    const { value } = this.props

    this.setState({value})
  }

  componentWillReceiveProps(nextProps) {
    const { value } = nextProps

    if (value !== this.props.value) this.setState({value})
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { child, value } = nextProps

    if (child !== this.props.child) return true
    if (value !== this.props.value) return true
    if (nextState !== this.state) return true
    return false
  }

  onValueChange(child, value) {
    if (child.id !== undefined) {
      this.props.editRiderItem({
        id: child.id,
        value: value
      })
    } else {
      this.props.createRiderItem({
        value: value,
        class: child.class,
        parent: child.parent,
        relation: child.relation,
        type: 'monitor',
        title: 'Monitor',
        position: 0
      })
    }
  }

  render() {
    const { view, child } = this.props
    const { value } = this.state

    return (
      <div className="range-form">
        <input className="fader"
          type="range"
          min="0"
          max="10"
          value={value}
          data-value={value*10}
          onChange={(e) => view.editable ? this.setState({value: e.target.value}) : null}
          onMouseUp={() => view.editable ? this.onValueChange(child, value) : null} />
      </div>
    )
  }
}

RangeForm.propTypes = {
  view: PropTypes.object,
  child: PropTypes.object,
  value: PropTypes.number,
  createRiderItem: PropTypes.func,
  editRiderItem: PropTypes.func
}

RangeForm.defaultProps = {
  view: {},
  child: {},
  value: null,
  createRiderItem: function() {},
  editRiderItem: function() {}
}

export default RangeForm



// WEBPACK FOOTER //
// ./src/components/rider/rider-output/forms/range-form.js